var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.75C15 19.1642 14.6642 19.5 14.25 19.5H2.25C1.83579 19.5 1.5 19.1642 1.5 18.75L1.5 5.25C1.5 4.83579 1.83579 4.5 2.25 4.5L14.25 4.5C14.6642 4.5 15 4.83579 15 5.25L15 8.25C15 8.66421 15.3358 9 15.75 9C16.1642 9 16.5 8.66421 16.5 8.25V5.25C16.5 4.00736 15.4926 3 14.25 3L2.25 3C1.00736 3 1.96167e-06 4.00736 1.90735e-06 5.25L0 18.75C-5.43176e-08 19.9926 1.00736 21 2.25 21H14.25C15.4926 21 16.5 19.9926 16.5 18.75V15.75C16.5 15.3358 16.1642 15 15.75 15C15.3358 15 15 15.3358 15 15.75V18.75Z",
    fill: "#2362a2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7803 12.5303C24.0732 12.2374 24.0732 11.7626 23.7803 11.4697L19.2803 6.96967C18.9874 6.67677 18.5126 6.67677 18.2197 6.96967C17.9268 7.26256 17.9268 7.73744 18.2197 8.03033L21.4393 11.25L8.25 11.25C7.83579 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.83579 12.75 8.25 12.75L21.4393 12.75L18.2197 15.9697C17.9268 16.2626 17.9268 16.7374 18.2197 17.0303C18.5126 17.3232 18.9874 17.3232 19.2803 17.0303L23.7803 12.5303Z",
    fill: "#2362a2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.0ca62fe8f5a8851cf9da092bce29d9b7.svg";
export { ForwardRef as ReactComponent };